module.exports = __webpack_public_path__ + "img/star.be5030ca.webp";